import React, { useEffect, useState } from 'react';

function LandingPage() {
  return (
    <div>
      <h1>Placeholder Landing Page</h1>
    </div>
  )
}

export default LandingPage